<template>
  <div>
    <Header />

    <Contents />

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Footer from "../../components/layout/Footer.vue";
import Contents from "./components/programa/Contents.vue";

export default {
  components: {
    Header,
    Contents,
    Footer,
  },
  mounted() {
    this.$store.commit("setPrivateView", "portada-bgi");
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  margin-bottom: 30px;
}
</style>
